import { type UseFormReturn } from 'react-hook-form';
import { useIntl } from 'react-intl';

import { type ChangePlanPricingPlanCardFormValues } from 'src/features/cards/components/ChangePricingPlanCardModalForm';
import { cardMessages } from 'src/features/cards/utils/messages';
import { Form, FormControl, FormControlStack, FormField, FormItem, FormLabel, FormMessage } from 'src/registry/ui/Form';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from 'src/registry/ui/Select';

type ChangePricingPlanCardFormProps = {
    form: UseFormReturn<ChangePlanPricingPlanCardFormValues>;
    onSubmit: (values: ChangePlanPricingPlanCardFormValues) => void;
    pricingPlanOptions?: { label: string; value: string }[];
};

const ChangePricingPlanCardForm = ({ form, onSubmit, pricingPlanOptions }: ChangePricingPlanCardFormProps) => {
    const { formatMessage } = useIntl();

    return (
        <Form form={form} onSubmit={form.handleSubmit(onSubmit)} variant="dialog">
            <FormField
                control={form.control}
                name="pricing_plan_id"
                render={({ field }) => (
                    <FormItem variant="dialog">
                        <FormLabel variant="dialog" required>
                            {formatMessage(cardMessages.pricingPlan)}
                        </FormLabel>
                        <FormControlStack>
                            <FormControl>
                                <Select value={field.value?.toString() ?? ''} onValueChange={field.onChange}>
                                    <SelectTrigger>
                                        <SelectValue placeholder={formatMessage(cardMessages.changePlanPlaceholder)} />
                                    </SelectTrigger>
                                    <SelectContent>
                                        {pricingPlanOptions?.map((pricingPlan) => (
                                            <SelectItem key={pricingPlan.value} value={pricingPlan.value.toString()}>
                                                {pricingPlan.label}
                                            </SelectItem>
                                        ))}
                                    </SelectContent>
                                </Select>
                            </FormControl>
                            <FormMessage />
                        </FormControlStack>
                    </FormItem>
                )}
            />
        </Form>
    );
};

export default ChangePricingPlanCardForm;
